import { fg } from '@atlaskit/platform-feature-flags/fg';
import type { RestorableRequestedMode } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

export const shouldRestoreMaxModeFromLastRequestedMode = (
	lastRequestedMode: RestorableRequestedMode | undefined,
): boolean => !fg('rovo_chat_restore_max_from_last_requested_mode') || lastRequestedMode === 'MAX';
